const type = 'SET_CARDS_LOADING';

const setCardsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setCardsLoading;
